// @flow

import * as React from 'react';
import { Confirmation, withConfirmation } from 'speed-js-react';
import Button from 'esm-web-pro/components/layout/GreyButton';
import { FormattedMessage } from 'react-intl';
import ApiClient from 'speed-js-core/src/api/ApiClient';
import connectAPI from 'speed-js-react/src/api/connectAPI';


type Props = {
    startExport: Function,
    confirm: (confirmation: Confirmation) => void,
}


const EITExport = (props: Props) => {
    const { startExport, confirm } = props;

    const confirmStartExport = () => {
        confirm({
            message: <FormattedMessage
                id="start-export-confirm"
                defaultMessage="Are you sure you want to start the export?"
            />,
            actions: {
                cancel: {
                    label: <FormattedMessage id="cancel-btn" defaultMessage="Cancel" />,
                    callback: () => {
                    },
                    type: 'negative',
                },
                confirm: {
                    label: <FormattedMessage id="confirm-btn" defaultMessage="Confirm" />,
                    callback: startExport,
                },
            },
        });
    };

    return (
        <Button
            label={<FormattedMessage id="export" defaultMessage="Export" />}
            onClick={confirmStartExport}
        />
    );
};

EITExport.defaultProps = {

};

const apiCallback = (apiClient: ApiClient) => ({
    startExport: {
        send: () => apiClient.resources.eitExport.startExport(),
    },
});

export default withConfirmation(connectAPI(apiCallback)(EITExport));
